module.exports = __webpack_public_path__ + "static/img/6298_phase_function_Paper_PointsHejduk_Prediction.7286d27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6298_phase_function_Paper_PointsHejduk_Prediction.png
// module id = iIcX
// module chunks = 0